import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Location from "@/components/landing/Location";
import Renders from "@/components/landing/Renders";
import Metrics from "@/components/landing/Metrics";
import Highlights from "@/components/landing/Highlights";
import TenantProfiles from "@/components/landing/TenantProfiles";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import WhatsappFab from "@/components/landing/WhatsappFab";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="font-body bg-[var(--co-bg)]">
      <Navbar />
      <Hero />
      <Location />
      <Renders />
      <Metrics />
      <Highlights />
      <TenantProfiles />
      <Contact />
      <Footer />
      <WhatsappFab />
    </main>
  );
}
